export default function getTodayDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatDate(dateString) {
  if (!dateString) return "-";

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "-";

  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return "-";

  const formatted = new Date(dateString).toLocaleString("en-IN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return formatted.replace(/\b(am|pm)\b/i, (match) => match.toUpperCase());
}

// Add this function at the top of your component
export function calculateDelayInTimeFormat(createdTime, modifiedTime) {
  if (!createdTime || !modifiedTime) return "00:00:00";

  try {
    const created = new Date(createdTime);
    const modified = new Date(modifiedTime);

    // Calculate difference in milliseconds
    const diffMs = modified - created;

    // If difference is negative (modified before created)
    if (diffMs < 0) return "00:00:00";

    // Convert to hours, minutes, seconds
    const totalSeconds = Math.floor(diffMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    // Format as HH:MM:SS with leading zeros
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  } catch (error) {
    console.error("Error calculating delay:", error);
    return "00:00:00";
  }
}

export function getFullName(person) {
  console.log("person", person);
  if (!person) return "-";

  return `${person.firstName ?? ""} ${person.lastName ?? ""}`.trim() || "-";
}

export const formatMaterialType = (value) => {
  if (!value) return "N/A";

  return value.replace(/([a-z])([A-Z])/g, "$1 $2").toUpperCase();
};
